import { createContext } from 'react';

import type { ProfileContextValue } from './ProfileContextProvider';

const ProfileContext = createContext<ProfileContextValue | null>(null);

ProfileContext.displayName = 'ProfileContext';
export default ProfileContext;
